module.exports = __webpack_public_path__ + "img/logo.8da4b4a5.png";